interface IImportScriptProps {
  async?: boolean;
  id?: string;
  resourceUrl: string;
  onload?: () => void;
  onerror?: () => void;
  preload?: () => Promise<boolean> | boolean;
  /**
   * Subresource Integrity hash, e.g. `sha384-...`. When set, the browser refuses to execute the
   * script unless its bytes hash to this value. Requires the origin to send CORS headers, which is
   * why `crossOrigin` is set alongside it — without that the browser cannot read the response to
   * check it, and the load fails.
   */
  integrity?: string;
  crossOrigin?: 'anonymous' | 'use-credentials';
}

const ImportScript = ({ async = false, id, resourceUrl, onload, onerror, integrity, crossOrigin }: IImportScriptProps) => {
  const script = document.createElement('script');

  // Set before `src` so both are in place when the fetch is kicked off.
  //
  // setAttribute rather than the IDL properties (`script.integrity = ...`): the attribute is what
  // the browser's integrity check actually reads, and property reflection for `integrity` is not
  // universally implemented — jsdom, which the unit tests run in, does not reflect it. Assigning the
  // property alone would leave no attribute on the element and silently disable the check.
  if (crossOrigin) script.setAttribute('crossorigin', crossOrigin);
  if (integrity) script.setAttribute('integrity', integrity);

  script.src = resourceUrl;
  script.async = async;
  if (id) script.id = id;
  if (onload) script.onload = onload;
  if (onerror) script.onerror = onerror;
  document.body.appendChild(script);
};

export default ImportScript;
